import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
type Props = {
	size: string;
};

export default /*#__PURE__*/_defineComponent({
  props: {
    size: null
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props as {
	size: string;
}



const click = () => {
	emit("click");
};
const className = computed(() => {
	let _classNameList = [];

	if (props.size) {
		_classNameList.push("_" + props.size);
	}

	return _classNameList.join(" ");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["UIButton", _unref(className)]),
    onClick: click
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})